import * as React from "react";
import { useSelector } from "react-redux";
import { Container, Segment, Header } from "semantic-ui-react";

import { taskSelector } from "../../task/selectors";

import { PhysiotherapyReferralReportV2 } from "./PhysiotherapyReferralReportV2";

export const AmendPhysiotherapyReferralReportV2: React.FunctionComponent = () => {
    const task = useSelector(taskSelector);

    if (!task) {
        return null;
    }

    return (
        <Container>
            <Segment>
                <Header as="h3">Requested Changes</Header>
                {task.notes}
            </Segment>
            <PhysiotherapyReferralReportV2 nextTaskRequired={false} isReportAmendment={true} />
        </Container>
    );
};
